import splashBottle from "@inventory/assets/splash-bottle.png";
import { IngredifindLogo } from "@inventory/components/common/IngredifindLogo";
import { brand } from "@inventory/lib/brand";

import React from "react";

import { Box, Stack, keyframes } from "@mui/material";

const bounce = keyframes`
  0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-4px); }
`;

const Dot = ({ delay }: { delay: number }) => (
  <Box
    sx={{
      width: 8,
      height: 8,
      borderRadius: "50%",
      bgcolor: brand.green,
      // Resting opacity for reduced-motion viewers; the bounce (which drives
      // opacity itself) only runs when motion is welcome.
      opacity: 0.9,
      "@media (prefers-reduced-motion: no-preference)": {
        animation: `${bounce} 1.4s ease-in-out ${delay}s infinite both`,
      },
    }}
  />
);

/**
 * Branded loading screen shown while Firebase auth initialises — mirrors the
 * "Splash" frame in the Product SOT.
 */
export const SplashScreen = () => (
  <Box
    component={"main"}
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      bgcolor: "background.default",
      px: 2,
      py: 6,
    }}
  >
    <IngredifindLogo height={28} />

    <Stack flexGrow={1} alignItems={"center"} justifyContent={"center"} gap={4}>
      <Box
        component={"img"}
        src={splashBottle}
        alt={""}
        aria-hidden
        sx={{ width: 200, maxWidth: "60%", height: "auto" }}
      />
      <Stack direction={"row"} gap={1}>
        <Dot delay={0} />
        <Dot delay={0.2} />
        <Dot delay={0.4} />
      </Stack>
    </Stack>
  </Box>
);
